const findUnreadMessages = (resultMessages) => {
  return resultMessages.filter(message => !message.isReadFromCRM);
}

export default findUnreadMessages;